import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { X } from "lucide-react";

const CookieBanner = () => {
  const { t } = useApp();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (val) => {
    localStorage.setItem("cookie_consent", val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-6 start-6 z-40 max-w-md bg-[#1E2235] border border-[#C9A84C]/30 p-5 shadow-2xl"
    >
      <button
        onClick={() => decide("declined")}
        className="absolute top-3 end-3 text-[#A0A5B5] hover:text-[#C9A84C]"
        aria-label="Close"
        data-testid="cookie-close-btn"
      >
        <X className="w-4 h-4" />
      </button>
      <p className="text-sm font-light text-[#F5F0E8]/85 leading-relaxed pe-6">
        {t("cookie_text")}
      </p>
      <div className="mt-4 flex gap-3">
        <button
          data-testid="cookie-accept-btn"
          onClick={() => decide("accepted")}
          className="btn-gold px-5 py-2 text-xs tracking-[0.18em] uppercase font-medium"
        >
          {t("cookie_accept")}
        </button>
        <button
          data-testid="cookie-decline-btn"
          onClick={() => decide("declined")}
          className="btn-ghost-gold px-5 py-2 text-xs tracking-[0.18em] uppercase"
        >
          {t("cookie_decline")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;